import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';

class CustomPagination extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pageSizeOptions: [10, 20, 50, 100],
            totalPageCount: 1,
        }
    }

    componentDidMount() {
        this.getPaging(this.props.pagination?.total, this.props.pagination?.pageSize);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.pagination !== this.props.pagination) {
            this.getPaging(
                this.props.pagination.total,
                this.props.pagination.pageSize
            );
        }
    }

    getPaging = (total, pageSize) => {
        let totalPageCounter = Math.ceil(total / pageSize);
        this.setState({ totalPageCount: totalPageCounter });
    };

    handlePagination = selectedPage => {
        this.props.onPage(selectedPage.selected + 1);
    };

    handlePageSize = e => {
        this.props.onPageSize(e.target.value);
    }

    handlePaginationByLevel = selectedPage => {
        this.props.onPage(selectedPage.selected + 1, this.props.paginationLevel);
    }

    handlePageSizeByLevel = e => {
        this.props.onPageSize(e.target.value, this.props.paginationLevel);
    }

    render() {
        return (
            <>
                <div className="px-5 py-3 flex justify-end text-black">
                    <div>
                        <div className="flex items-center">
                            <p>{this.props.titlePageSize}</p>
                            <select id="btnviewperpage" value={this.props.pagination.pageSize} className="outline-none rounded-md bg-transparent border font-bold border-blue-900 p-1 mx-5" onChange={this.props.paginationLevel ? this.handlePageSizeByLevel : this.handlePageSize}>
                                {
                                    this.state.pageSizeOptions.map((pageSize, idx) =>
                                        <option key={idx} value={pageSize}>{pageSize}</option>
                                    )
                                }
                            </select>
                            <ReactPaginate
                                className="flex items-center"
                                pageLinkClassName="px-2 py-1"
                                activeClassName="bg-darkblue text-white rounded"
                                previousClassName="px-2 py-1"
                                nextClassName="px-2 py-1"
                                pageRangeDisplayed={1}
                                marginPagesDisplayed={2}
                                forcePage={this.props.pagination.current - 1}
                                breakLabel="..."
                                nextLabel=">"
                                previousLabel="<"
                                onPageChange={this.props.paginationLevel ? this.handlePaginationByLevel : this.handlePagination}
                                pageCount={this.state.totalPageCount}
                                renderOnZeroPageCount={null}
                            />
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default CustomPagination;